import {
  HIDE_HELP,
  SET_CURRENT_HELP_TAB,
  SET_CURRENT_PAGE_HELP,
  SHOW_HELP,
} from 'actions/helpPopover';

const defaultState = {
  helpLocation: null,
  helpUpdatedAt: null,
  currentPageHelpLocation: null,
  refreshButtonLocation: null,
  isOpen: false,
  currentTab: null,
};

export default function helpPopover(state = defaultState, action) {
  switch (action.type) {
    case SHOW_HELP: {
      const {
        helpLocation: payloadLocation,
        actsAsToggle,
        tab,
      } = action.payload;
      const {
        currentPageHelpLocation,
        helpLocation: prevHelpLocation,
        isOpen: prevIsOpen,
        refreshButtonLocation,
      } = state;

      const helpLocation =
        payloadLocation || prevHelpLocation || currentPageHelpLocation;

      const wasRendered = !!(prevHelpLocation && prevIsOpen);

      return {
        ...state,
        // Used to force reloads when user clicks a button multiple times:
        helpUpdatedAt: new Date(),
        helpLocation,
        isOpen: actsAsToggle ? !wasRendered : true,
        currentTab: tab || state.currentTab,
        // Clear the refresh button if user is going to the same Help Page it references:
        refreshButtonLocation:
          helpLocation === refreshButtonLocation ? null : refreshButtonLocation,
      };
    }
    case SET_CURRENT_PAGE_HELP: {
      const currentPageHelpLocation = action.payload;
      const { helpLocation: prevHelpLocation, isOpen } = state;

      // Autoset helpLocation (when null) if `isOpen`, this happens due to sessionStorage:
      const helpLocation =
        prevHelpLocation ?? (isOpen && currentPageHelpLocation);

      // Clear the refresh button if user navigated to a page whose currentPageHelpLocation matches their current helpLocation:
      const hideRefresh = !isOpen || currentPageHelpLocation === helpLocation;

      return {
        ...state,
        helpLocation,
        currentPageHelpLocation,
        refreshButtonLocation: hideRefresh ? null : currentPageHelpLocation,
      };
    }
    case SET_CURRENT_HELP_TAB: {
      return {
        ...state,
        currentTab: action.payload,
      };
    }
    case HIDE_HELP: {
      return {
        ...defaultState,
        currentPageHelpLocation: state.currentPageHelpLocation,
      };
    }
    default:
      return state;
  }
}
